<template>
  <button
    type="button"
    :aria-pressed="active"
    :aria-label="active ? $t('favorite.saved') : $t('favorite.save')"
    :title="active ? $t('favorite.saved') : $t('favorite.save')"
    class="fav-btn"
    :class="showLabel ? 'fav-btn--labeled' : 'fav-btn--icon'"
    @click.stop.prevent="onClick"
  >
    <svg
      viewBox="0 0 24 24"
      :width="size"
      :height="size"
      aria-hidden="true"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      :fill="active ? 'currentColor' : 'none'"
      class="shrink-0"
      :class="active ? 'text-osn-red-00' : 'text-osn-grey-01'"
    >
      <path
        d="M12 21s-7.5-4.6-10-9.2C.6 8.9 2 5.5 5.3 5.5c1.9 0 3.2 1.1 4 2.2.8-1.1 2.1-2.2 4-2.2 3.3 0 4.7 3.4 3.3 6.3C19.5 16.4 12 21 12 21z"
      />
    </svg>
    <span
      v-if="showLabel"
      class="ml-2 text-[15px] font-medium"
      :class="active ? 'text-osn-red-00' : 'text-osn-grey-01'"
    >{{ active ? $t('favorite.saved') : $t('favorite.save') }}</span>
  </button>
</template>

<script setup lang="ts">
import {computed, onMounted, ref} from 'vue'
import {useFavoritesStore} from '~/stores/favorites'

const props = withDefaults(defineProps<{
  spaceId: number
  size?: number
  showLabel?: boolean
}>(), {
  size: 22,
  showLabel: false,
})

const favoritesStore = useFavoritesStore()
// 收藏狀態只在 client 載入（localStorage/API，見 plugins/favorites.client.ts），
// SSR store 恆空。首次 hydration 一律回 false 以對齊 SSR，掛載後才反映真實狀態，
// 避免 hydration mismatch（訪客已有收藏時 SSR 空心/client 實心會不一致）。
const mounted = ref(false)
onMounted(() => {
  mounted.value = true
})
const active = computed(() => mounted.value && favoritesStore.isFavorited(props.spaceId))

function onClick(): void {
  favoritesStore.toggle(props.spaceId)
}
</script>

<style scoped lang="scss">
.fav-btn {
  @apply inline-flex items-center justify-center cursor-pointer;
}

// 卡片上的圓形疊圖按鈕(白底、陰影),與 ShareButton compact 一致
.fav-btn--icon {
  @apply w-9 h-9 rounded-full bg-osn-white-00 shadow-md;
}

// 詳情頁的外框膠囊按鈕(帶文字)
.fav-btn--labeled {
  @apply h-[44px] px-4 rounded-[50px] border border-osn-grey-02 bg-osn-white-00;
}
</style>
